/**
 * Car/skin catalog. All cars handle identically — differences are visual.
 * Keep prices reasonable so the player unlocks something within the first
 * few runs (motivation). 'default' is free and pre-owned.
 */
export interface CarDef {
  id: string;
  name: string;
  price: number; 
  bodyColor: number;
  cabinColor: number;
  trim: number;
  emissive?: number;
}

export const CARS: CarDef[] = [
  { id: "default", name: "Crimson Coupe", price: 0, bodyColor: 0xff2a55, cabinColor: 0x111219, trim: 0xfff4d6 },
  { id: "midnight", name: "Midnight Blade", price: 800, bodyColor: 0x101428, cabinColor: 0x222840, trim: 0x4dd0e1, emissive: 0x18ffff },
  { id: "pearl", name: "Pearl Drift", price: 1500, bodyColor: 0xf2f4ff, cabinColor: 0x1a1f2e, trim: 0xc77dff },
  { id: "neon", name: "K-town Neon", price: 3000, bodyColor: 0x140a22, cabinColor: 0x111111, trim: 0xff66cc, emissive: 0xff4dd2 },
  { id: "gold", name: "Suedegod Gold", price: 6500, bodyColor: 0xffcd3c, cabinColor: 0x1a1303, trim: 0xfff0c0, emissive: 0xffaa00 },
];

export function carById(id: string): CarDef {
  return CARS.find((c) => c.id === id) ?? CARS[0];
}
